
export default {
  state: {
    county_list: [],
  },

  getters: {
    getCountyData(state) {
      return state.county_list
    },
  },

  mutations: {
    setCountyData(state, data) {
      state.county_list = data
    },
  },

  actions: {
      changeCountyData(context, data) {
      context.commit("setCountyData", data)
    },
  },
};
